import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CriteoAlignmentInfo } from '@common/components';
import { DeliveryInformationStoreService, CriteoAlignmentService } from '@common/services';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

/**
 * criteo連携情報
 */
@Component({
  selector: 'asw-plan-review-criteo',
  templateUrl: './plan-review-criteo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanReviewCriteoComponent extends SupportComponent {
  /** criteoに連携する支払総額 */
  @Input()
  set totalAmount(value: number | undefined) {
    this._totalAmount = value;
    this.refresh();
  }
  get totalAmount(): number | undefined {
    return this._totalAmount;
  }
  private _totalAmount?: number;

  /** criteo連携情報 */
  public criteoData: CriteoAlignmentInfo = {};

  /**
   * コンストラクタ
   */
  constructor(
    private _common: CommonLibService,
    private _deliveryInformationStoreService: DeliveryInformationStoreService,
    private _criteoService: CriteoAlignmentService
  ) {
    super(_common);
  }

  /**
   * 初期表示処理
   */
  init(): void {}

  refresh(): void {
    // 往復空席照会結果画面で作成したのと同内容のcriteo連携情報を作成
    const criteoData = this._criteoService.createCriteoAlignmentInfo();
    // プラン確認追加項目を設定
    criteoData.criteoTotalAmount = String(this.totalAmount);
    criteoData.criteoTransactionId = ''; // 空の値を設定
    this.criteoData = criteoData;
    this._deliveryInformationStoreService.setDeliveryInformationByKey('planReviewInformation', 'criteo', criteoData);
  }

  reload(): void {}
  destroy(): void {}
}
